import GenerationTimeout from '$/_const/GenerationTimeout.ts';
import type { Itinerary } from '$/models/Itinerary.model.ts';

export const generationStuckAt = (itinerary: Pick<Itinerary, 'updated_at'>): number =>
  Date.parse(itinerary.updated_at) + GenerationTimeout.STALE_AFTER_MS;

const isGenerationStuck = (itinerary: Pick<Itinerary, 'is_generating' | 'updated_at'>, now: number): boolean =>
  itinerary.is_generating && now >= generationStuckAt(itinerary);

export default isGenerationStuck;
